import { Button, Divider } from '@mui/material';
import styles from './Header.module.css';
import NavLink from '../commons/NavLink';
import WebUploaderLink from './WebUploaderLink';
import UserRole from '../../model/user-role';
import { ADMIN_ACCESS } from '../commons/AccesRoles';

interface IProps {
  links: Array<{ link: string; label: string }>;
  userRole?: UserRole;
}

function HeaderMenu({ links, userRole }: IProps) {
  return (
    <>
      {!!userRole && (ADMIN_ACCESS.includes(userRole)) && <WebUploaderLink />}
      <Divider
        key='divider_webuploader'
        orientation='vertical'
        sx={{ height: 30 }}
        variant='middle'
        flexItem
      />
      {links.map((link, index) => (
        <div key={link.label} className={styles.headerMenuItem}>
          <Button
            key={link.label}
            component={NavLink}
            to={link.link}
            activeClassName={styles.active}
          >
            {link.label}
          </Button>
          {index !== links.length - 1 && (
            <Divider
              key={'divider_' + link.label}
              orientation='vertical'
              sx={{ height: 30 }}
              variant='middle'
              flexItem
            />
          )}
        </div>
      ))}
    </>
  );
}

export default HeaderMenu;
